<template>
  <div v-if="entries.length > 0" class="card mb-3">
    <button
      class="card-header bg-light d-flex justify-content-between align-items-center w-100 border-0 text-start"
      type="button"
      @click="panelOpen = !panelOpen"
    >
      <h5 class="mb-0">
        Price Overrides
        <span v-if="hasAnyOverride" class="badge bg-warning text-dark ms-2"
          >Mixed Prices</span
        >
      </h5>
      <font-awesome-icon :icon="panelOpen ? 'chevron-up' : 'chevron-down'" />
    </button>
    <div v-show="panelOpen" class="card-body">
      <p class="text-muted small mb-3">
        Leave blank to use the default price ({{ defaultPrice ?? "—" }}
        EUR/MWh). Enter a value to override the price for a specific company.
      </p>
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Company</th>
            <th>Amount (MWh)</th>
            <th class="price-override-col">Price Override (EUR/MWh)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.key">
            <td>{{ entry.company_name }}</td>
            <td>{{ entry.amount }}</td>
            <td>
              <input
                type="number"
                class="form-control form-control-sm"
                :value="modelValue[entry.key] ?? ''"
                @input="
                  onInput(entry.key, ($event.target as HTMLInputElement).value)
                "
                min="0"
                step="0.0001"
                placeholder="Default"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps<{
  entries: { key: number; company_name: string; amount: number }[];
  defaultPrice: number | string;
  defaultOpen?: boolean;
}>();

const modelValue = defineModel<Record<number, number | null>>({
  required: true,
});

const panelOpen = ref(props.defaultOpen ?? false);

const hasAnyOverride = computed(() =>
  Object.values(modelValue.value).some((p) => p !== null && p !== undefined)
);

const onInput = (key: number, value: string) => {
  const updated = { ...modelValue.value };
  if (value === "" || value === null || value === undefined) {
    updated[key] = null;
  } else {
    updated[key] = parseFloat(value);
  }
  modelValue.value = updated;
};
</script>

<style scoped>
.price-override-col {
  width: 180px;
}
</style>
